import useAuthState$1 from './useAuthState.js';

/**
 * A hook to return the authenticated status of the current user
 * @returns {boolean} Whether the current user is logged in
 */

var useLoggedIn = function useLoggedIn() {
  var _useAuthState = useAuthState$1(),
      loggedIn = _useAuthState.loggedIn;

  return loggedIn;
};

var useLoggedIn$1 = useLoggedIn;

export { useLoggedIn$1 as default };
